import { render, staticRenderFns } from "./QuizInfo.vue?vue&type=template&id=63429bd4&"
import script from "./QuizInfo.vue?vue&type=script&lang=js&"
export * from "./QuizInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports